import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../../common_components/Header";
import DatePicker from "react-datepicker";
import Footer from "../../common_components/Footer";
import Drawer from "../../common_components/Drawer";
import {
    getUserHotelEnquiry_action,
    insertHotelEnquiry_action
} from "../../actions/exhibitor_module_actions/hotel_form_action/hotel_form_action";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ConfirmationModal from "../../common_components/confirmationa_modal";
import HeaderLogin from '../../common_components/HeaderLogin';
import { ToastContainer, toast } from "react-toastify";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../utils/withRouter";
import moment from "moment";
import Modal from "react-modal";
import Loader from "../../utils/Loader";
import {
    clearSessionStorage,
    countryActionId,
    stateActionId,
    cityActionId,
    pincodeActionId,
    RoomTypeActionId,
    toastError, GSTvalidationActionId,
    toastSuccess, countryIWithCodeActionId
} from "../../utils/constants";
import Pagination from "../../utils/pagination";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from "../../actions/fillCombo_action";
import StepHeader from "./stepHeader";
import PrimaryChapter from "./primary_chapter";
import Description from "./description";
import Resizer from "react-image-file-resizer";
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../utils/Validator";
import $ from "jquery";
import {
    getHotelDetails_action,
} from "../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/hotelEnquiry_action/hotelEnquiry_action";
import VisitorHeader2 from "../../common_components/visitor_module_header2";
import VisitorDrawer from "../../common_components/visitor_module_drawer";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";
import VisitorTopMenu from "../../common_components/visitor_module_topmenu";
/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps getUserHotelEnquiry_action
insertHotelEnquiry_action
*/
const mapStateToProps = state => ({
    ...state
})

class BookingForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            isOpenConfirmationModal: false,
            exhID: '',
            EventDate: '',
            SetupDate: '',
            DismantleDate: '',
            ExhibitionAddress: '',
            HotelDetailsList: [],
            isOpen: false,
            RoleID: sessionStorage.getItem("RoleIDSS"),
            FirstName: '',
            FirstNameErr: '',
            LastName: '',
            LastNameErr: '',
            EmailId: '',
            EmailIdErr: '',
            CountryId: '',
            CountryErr: '',
            MobileNo: '',
            MobileNoErr: '',
            NumberofRooms: '',
            MobileNoErr: '',
            NumberofRoomsList: [],
            countryList: [],
            preMobNo: '',
            RoomTypeList: []
        }
        this.getFillList = this.getFillList.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.inputValidation = this.inputValidation.bind(this)
        this.getDetails = this.getDetails.bind(this)
        this.onCancleForm = this.onCancleForm.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.handleSubmit()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }
    componentDidMount() {
        this.getFillList(countryActionId, '', '', '', '')
        this.getFillList(RoomTypeActionId, '', '', '', '')
        this.setState({
            from: this.props.location.state != null && this.props.location.state.from ? this.props.location.state.from : null,
            exhID: this.props.location.state != null && this.props.location.state.exhID ? this.props.location.state.exhID : null,
        }, () => {
            this.getDetails()
            this.getHotelDetails()
            window.scrollTo(0, 0);
        })
    }

    getHotelDetails() {
        const { HotelDetailsList } = this.state
        this.setState({ isLoading: true })
        this.props
            .getHotelDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, HotelDetailsList: data.data })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getDetails() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, EventDate, DismantleDate, SetupDate, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state        // this.setState({ isLoading: true })
        this.props
            .getUserHotelEnquiry_action(exhID) // DYNAMIC PARAMS HAS TO BE PLACE LATER <<==
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0][0])
                    var mobNo = data.data[0][0].MobileNo != '' && data.data[0][0].MobileNo != null ? data.data[0][0].MobileNo.split('-') : []
                    var preMob = mobNo.length == 2 ? mobNo[0] : ''
                    var mobNo1 = mobNo.length == 2 ? mobNo[1] : mobNo.length == 1 ? mobNo[0] : ''
                    this.setState({
                        Name: data.data[0][0].PersonIncharge,
                        companyName: data.data[0][0].CompanyName,
                        DismantleDate: data.data[0][0].DismantleDate,
                        EventDate: data.data[0][0].EventDate,
                        mobNo: mobNo1,
                        preMobNo: preMob,
                        Email: data.data[0][0].PrimaryEmail,
                        SetupDate: data.data[0][0].SetupDate,
                        ExhibitionAddress: data.data[0][0].ExhibitionAddress
                    })
                }
            }).catch(e => {
                console.log(e)
            })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID === countryIWithCodeActionId) {
                        if (data.data.length > 0) {
                            console.log("country data", data.data[0])
                            console.log(data.data[0])
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []

                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", data.data[0]['ExhibitionDateFrom'])
                            sessionStorage.setItem("exhibitionDateTo", data.data[0]['ExhibitionDateTo'])
                            sessionStorage.setItem("sessionLogoPath", data.data[0]['Logo'])
                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])

                            this.setState({
                                isDataLoad: true,
                                isExibitionClosed: data.data[0]['IsExhibitionClosed'] != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                isregistrationLinkClosed: data.data[0]['isregistrationLinkClosed'] != null && data.data[0]['isregistrationLinkClosed'] == 1 ? true : false,
                            })
                            console.log("country data", emailArr, mobileArr, JSON.parse(sessionStorage.getItem("sessionExhibitionMobileNo")))
                            this.setState({ isLoading: false })

                        } else {
                            this.setState({ isLoading: false, invalidLink: true })
                        }

                    }

                    if (actionID == countryActionId) {
                        this.setState({ countryList: data.data })
                    }
                    if (actionID == RoomTypeActionId) {
                        this.setState({ RoomTypeList: data.data })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    handleSubmit() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, checkInDate, checkInDateErr, checkOutDate, checkOutDateErr, code, NOP, NOPErr, NOR, NORErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, singleOcc, doubleOcc, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state
        this.inputValidation().then(res => {
            if (!res) {
                console.log(doubleOcc + singleOcc, NOR)
                if (NOR != (parseInt(doubleOcc) + parseInt(singleOcc))) {
                    toastError("No of rooms should be equal to sum of single occupancy and double occupancy")
                } else {
                    this.setState({ isLoading: true })
                    var finalMobNo = ''
                    if (preMobNo != '' && preMobNo != null) {
                        finalMobNo = `${preMobNo}-${mobNo}`
                    } else {
                        finalMobNo = mobNo
                    }
                    console.log(
                        Name,
                        companyName,
                        Email,
                        finalMobNo,
                        checkInDate,
                        checkOutDate,
                        NOP,
                        NOR,
                        singleOcc,
                        doubleOcc,
                        remark
                    )
                    this.props
                        .insertHotelEnquiry_action(exhID,
                            Name,
                            companyName,
                            Email,
                            finalMobNo,
                            checkInDate,
                            checkOutDate,
                            NOP,
                            NOR,
                            singleOcc,
                            doubleOcc,
                            remark)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isLoading: false })
                                toastSuccess("Form Submitted Successfully")
                                setTimeout(() => {
                                    this.props.navigate(-1)
                                }, 1000);
                            }
                        }).catch((e) => {
                            console.log(e);
                        });
                }
            } else {
                toastError("Please fill mandatory fields")
            }
        })

    }

    inputValidation() {
        const { isLoading, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, singleOcc, doubleOcc, NOP, NOPErr, NOR, NORErr, singleOccErr, doubleOccErr, checkInDate, checkInDateErr, checkOutDate, checkOutDateErr, code, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state
        return new Promise((resolve, reject) => {
            var Errr = false
            if (companyName.trim() == '' || companyName.trim() == null) {
                this.setState({ companyNameErr: "Please Enter Organization Name" })
                Errr = true
            }
            if (Name.trim() == '' || Name.trim() == null) {
                this.setState({ NameErr: "Please Enter Name" })
                Errr = true
            }
            if (Email.trim() == '' || Email.trim() == null) {
                this.setState({ EmailErr: "Please Enter Email" })
                Errr = true
            }
            if (mobNo.trim() == '' || mobNo.trim() == null) {
                this.setState({ mobNoErr: "Please Enter Mobile" })
                Errr = true
            }
            if (checkInDate == '' || checkInDate == null) {
                this.setState({ checkInDateErr: "Please Enter CheckIn date" })
                Errr = true
            }
            if (checkOutDate == '' || checkOutDate == null) {
                this.setState({ checkOutDateErr: "Please Enter CheckOut date" })
                Errr = true
            }
            if (NOP == '' || NOP == null) {
                this.setState({ NOPErr: "Please Enter No. of Pax" })
                Errr = true
            }
            if (NOR == '' || NOR == null) {
                this.setState({ NORErr: "Please Enter No. of Rooms" })
                Errr = true
            }
            if (singleOcc == '' || singleOcc == null) {
                this.setState({ singleOccErr: "Please Enter Single Occupancy" })
                Errr = true
            }
            if (doubleOcc == '' || doubleOcc == null) {
                this.setState({ doubleOccErr: "Please Enter Double Occupancy" })
                Errr = true
            }

            resolve(Errr)
        })
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }


    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    onCancleForm(e) {
        e.preventDefault()
        this.props.navigate(-1)
    }

    handleRoomChange = (index, field, value) => {
        this.setState(prevState => {
            const list = [...prevState.NumberofRoomsList];
            list[index][field] = value;
            return { NumberofRoomsList: list };
        });
    };

    handleMemberChange = (roomIndex, memberIndex, field, value) => {
        this.setState(prevState => {
            const updatedList = [...prevState.NumberofRoomsList];

            updatedList[roomIndex] = {
                ...updatedList[roomIndex],
                RoomMemberList: updatedList[roomIndex].RoomMemberList.map((member, i) => {
                    if (i === memberIndex) {
                        return {
                            ...member,
                            [field]: value
                        };
                    }
                    return member;
                })
            };

            return { NumberofRoomsList: updatedList };
        });
    };

    handleRoomTypeChange = (index, roomTypeId) => {
        const getRoomMembers = (type) => {
            const count = type == 1 ? 1 : 2;
            return Array.from({ length: count }, (_, i) => ({
                memberId: i + 1,
                name: "",
                age: ""
            }));
        };

        this.setState(prevState => {
            const list = [...prevState.NumberofRoomsList];

            list[index] = {
                ...list[index],
                RoomTypeId: roomTypeId,
                RoomMemberList: getRoomMembers(roomTypeId)
            };

            return { NumberofRoomsList: list };
        });
    };

    render() {
        const {
            isLoading,
            isOpenConfirmationModal,
            exhID,
            EventDate,
            SetupDate,
            DismantleDate,
            ExhibitionAddress,
            HotelDetailsList,
            isOpen,
            RoleID,
            FirstName,
            FirstNameErr,
            LastName,
            LastNameErr,
            EmailId,
            EmailIdErr,
            CountryId,
            CountryErr,
            MobileNo,
            MobileNoErr,
            NumberofRooms,
            NumberofRoomsErr,
            NumberofRoomsList,
            countryList,
            preMobNo,
            RoomTypeList
        } = this.state
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <>
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                        <ExhibitorHeader />
                    ) : (
                        <VisitorHeader2 />
                    )}
                    {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
                        <ExhibitorDrawer />
                    ) :
                        <VisitorDrawer />
                    }

                    {/* PAGE */}
                    <div
                        className={"with-dr-container"}
                        style={{ marginTop: RoleID == 1 ? "50px" : "20px" }}
                    >
                        <div className="main-container">
                            <div className="row">
                                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                                    1 ? (
                                    <ExhibitorTopMenu />
                                ) : <VisitorTopMenu />}
                            </div>
                            {/* {from == 'dashboard' ? <ExhibitorHeader /> : isDataLoad ? <HeaderLogin /> : null}
                            {from == 'dashboard' ? <ExhibitorDrawer /> : null} */}

                            <div >
                                <div className="side-app">
                                    <div className="container-fluid mt-top-space p-0" >
                                        <div className="row justify-content-center">
                                            <div className="col-xl-12 col-lg-11 col-md-12">

                                                <div className="card shadow-sm rounded-2">
                                                    <div className="card-body p-3">

                                                        {/* Header */}
                                                        <h3 className="text-center fw-bold mb-3">
                                                            BOOKING FORM
                                                        </h3>

                                                        {/* Event Details */}
                                                        <div className="row">
                                                            <div className="col-md-6 mt-0">
                                                                <p><strong>Setup Date :</strong> {SetupDate || ""}</p>
                                                                <p><strong>Event Date :</strong> {EventDate || ""}</p>
                                                                {/* <p><strong>Dismantle Date :</strong> {DismantleDate || ""}</p> */}
                                                                <p><strong>Venue :</strong> {ExhibitionAddress || ""}</p>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        {/* Personal Info */}
                                                        <div className="row g-3">
                                                            <p className="mb-0"><strong>Enter your details</strong></p>
                                                            <div className="col-md-4 mt-0">
                                                                <label className="form-label">
                                                                    First  Name <span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={FirstName}
                                                                    maxLength="200"
                                                                    onChange={(e) => this.setState({ FirstName: e.target.value, FirstNameErr: "" })}
                                                                />
                                                                <span className="text-danger">{FirstNameErr}</span>
                                                            </div>
                                                            <div className="col-md-4 mt-0">
                                                                <label className="form-label">
                                                                    Last  Name <span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={LastName}
                                                                    maxLength="200"
                                                                    onChange={(e) => this.setState({ LastName: e.target.value, LastNameErr: "" })}
                                                                />
                                                                <span className="text-danger">{LastNameErr}</span>
                                                            </div>
                                                            <div className="col-md-4 mt-0">
                                                                <label className="form-label">
                                                                    Email <span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={EmailId}
                                                                    maxLength="200"
                                                                    onChange={(e) => this.setState({ EmailId: e.target.value, LastNameErr: "" })}
                                                                />
                                                                <span className="text-danger">{EmailIdErr}</span>
                                                            </div>
                                                            <div className="col-md-4 mt-0">
                                                                <label className="form-label">
                                                                    Country <span className="text-danger">*</span>
                                                                </label>
                                                                <select className="form-control"
                                                                    value={CountryId}
                                                                    // disabled={isView}
                                                                    onChange={(e) => this.setState({ CountryId: e.target.value })}  >
                                                                    <option value={''}>Select</option>
                                                                    {
                                                                        countryList.length > 0 && countryList.map(data => (
                                                                            <option value={data.Code} key={data.Code}>{data.Description}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <span className="text-danger">{CountryErr}</span>
                                                            </div>
                                                            <div className="col-md-4 mt-0">
                                                                <label className="form-label">
                                                                    Mobile no <span className="text-danger">*</span>
                                                                </label>
                                                                <div className="input-group">
                                                                    <span className="input-group-text">{preMobNo || 'ISD'}</span>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={MobileNo}
                                                                        maxLength="10"
                                                                        onChange={(e) =>
                                                                            /^[0-9]*$/.test(e.target.value)
                                                                                ? this.setState({ MobileNo: e.target.value, mobNoErr: "" })
                                                                                : null
                                                                        }
                                                                    />
                                                                </div>
                                                                <span className="text-danger">{MobileNoErr}</span>
                                                            </div>
                                                            <div className="col-md-4 mt-0">
                                                                <label className="form-label">
                                                                    Number of Rooms <span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={this.state.NumberofRooms}
                                                                    maxLength="50"
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;

                                                                        this.setState({
                                                                            NumberofRooms: value,
                                                                            NumberofRoomsErr: ""
                                                                        }, () => {
                                                                            const count = parseInt(value) || 0;

                                                                            this.setState(prevState => {
                                                                                let updatedList = [...prevState.NumberofRoomsList];

                                                                                if (updatedList.length < count) {
                                                                                    for (let i = updatedList.length; i < count; i++) {
                                                                                        updatedList.push({
                                                                                            roomNumber: i + 1,
                                                                                            checkInDate: null,
                                                                                            checkOutDate: null,
                                                                                            RoomTypeId: '',
                                                                                            RoomMemberList: []
                                                                                        });
                                                                                    }
                                                                                } else if (updatedList.length > count) {
                                                                                    updatedList = updatedList.slice(0, count);
                                                                                }

                                                                                return { NumberofRoomsList: updatedList };
                                                                            });
                                                                        });
                                                                    }}
                                                                />
                                                                <span className="text-danger">{NumberofRoomsErr}</span>
                                                            </div>

                                                        </div>

                                                        <div className="row mt-4">
                                                            {this.state.NumberofRoomsList.map((room, index) => (
                                                                <div className="col-md-4 mb-3" key={index}>
                                                                    <div className="card shadow-sm">
                                                                        <div className="card-header text-white" style={{ background: '#3dbca7' }}>
                                                                            Room {room.roomNumber}
                                                                        </div>

                                                                        <div className="card-body">

                                                                            {/* Check In */}
                                                                            <div className="form-group mb-2">
                                                                                <label>Check In<span className="text-danger">*</span></label>
                                                                                <DatePicker
                                                                                    selected={room.checkInDate}
                                                                                    className="form-control"
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    onChange={(date) =>
                                                                                        this.handleRoomChange(index, "checkInDate", date)
                                                                                    }
                                                                                />
                                                                            </div>

                                                                            {/* Check Out */}
                                                                            <div className="form-group mb-3">
                                                                                <label>Check Out<span className="text-danger">*</span></label>
                                                                                <DatePicker
                                                                                    selected={room.checkOutDate}
                                                                                    className="form-control"
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    onChange={(date) =>
                                                                                        this.handleRoomChange(index, "checkOutDate", date)
                                                                                    }
                                                                                />
                                                                            </div>

                                                                            {/* Room Type */}
                                                                            <div className="form-group mb-2">
                                                                                <label>Room Type<span className="text-danger">*</span></label>
                                                                                <select className="form-control"
                                                                                    value={room.RoomTypeId}
                                                                                    onChange={(e) =>
                                                                                        this.handleRoomTypeChange(index, e.target.value)
                                                                                    }
                                                                                >
                                                                                    <option value={''}>Select</option>
                                                                                    {
                                                                                        RoomTypeList.length > 0 && RoomTypeList.map(data => (
                                                                                            <option value={data.RoomTypeID} key={data.RoomTypeID}>{data.RoomTypeName}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>
                                                                            </div>

                                                                            {/* Members */}
                                                                            {room.RoomMemberList.length > 0 && (
                                                                                <div>
                                                                                    <strong>Members<span className="text-danger">*</span></strong>

                                                                                    {room.RoomMemberList.map((member, mIndex) => (
                                                                                        <div key={mIndex} className="border p-2 mb-2 rounded">
                                                                                            <div className="row">

                                                                                                {/* First Name */}
                                                                                                <div className="col-md-6">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        placeholder="First Name"
                                                                                                        value={member.FirstName || ""}
                                                                                                        onChange={(e) =>
                                                                                                            this.handleMemberChange(
                                                                                                                index,
                                                                                                                mIndex,
                                                                                                                "FirstName",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                    />
                                                                                                </div>

                                                                                                {/* Last Name */}
                                                                                                <div className="col-md-6">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        placeholder="Last Name"
                                                                                                        value={member.LastName || ""}
                                                                                                        onChange={(e) =>
                                                                                                            this.handleMemberChange(
                                                                                                                index,
                                                                                                                mIndex,
                                                                                                                "LastName",
                                                                                                                e.target.value
                                                                                                            )
                                                                                                        }
                                                                                                    />
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* <hr className="my-3" /> */}

                                                        {/* Dates */}
                                                        {/* <div className="col-md-4">
                                                            <label className="form-label">
                                                                Check In Date <span className="text-danger">*</span>
                                                            </label>
                                                            <DatePicker
                                                                selected={checkInDate}
                                                                className="form-control"
                                                                dateFormat="dd/MM/yyyy"
                                                                onChange={(date) =>
                                                                    this.setState({
                                                                        checkInDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                                        checkInDateErr: ""
                                                                    })
                                                                }
                                                            />
                                                            <span className="text-danger">{checkInDateErr}</span>
                                                        </div> */}

                                                        {/* Buttons */}
                                                        <div className="d-flex justify-content-end gap-2 mt-3">
                                                            <button className="btn btn-aqua px-4"
                                                                //  onClick={this.handleSubmit}
                                                                onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                                            >
                                                                Submit
                                                            </button>
                                                            <button className="btn btn-gray px-4" onClick={this.onCancleForm}>
                                                                Back
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-4">
                            <div className="modal-header bg-aqua text-white py-2">
                                <h5 class="modal-title modal_title_text">Package Details</h5>
                                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen: false })} ></button>
                            </div>
                            <div class="modal-body">
                                <p className="m-1">
                                    <strong>Package Includes:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[2]?.length > 0 &&
                                            HotelDetailsList[2].map((item, index) => (
                                                <li key={index}>
                                                    {item.Package || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                                <p className="m-1">
                                    <strong>Basic Facilities:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[3]?.length > 0 &&
                                            HotelDetailsList[3].map((item, index) => (
                                                <li key={index}>
                                                    {item.BasicFacility || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                                <p className="m-1">
                                    <strong>Additional Amenities:</strong>
                                    <ul className="m-1" style={{ listStyleType: "disc" }}>
                                        {HotelDetailsList[4]?.length > 0 &&
                                            HotelDetailsList[4].map((item, index) => (
                                                <li key={index}>
                                                    {item.AdditionalAmenities || "-"}
                                                </li>
                                            ))}
                                    </ul>
                                </p>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }

}


export default withRouter(connect(null, {
    fill_action, getUserHotelEnquiry_action,
    insertHotelEnquiry_action, getHotelDetails_action
})(BookingForm));